import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcAssurance = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M2 4.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4.785l-.415-.093a5 5 0 0 0-2.17 0l-1.384.308h-.465l-2.709-4.514a1 1 0 0 0-1.725.018l-3.073 5.378-1.665-3.33a1 1 0 0 0-1.788 0L3.382 9.5H2v-5Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "m13.617 10.14-1.596-2.661-3.153 5.517a1 1 0 0 1-1.762-.049L5.5 9.737l-.606 1.21A1 1 0 0 1 4 11.5H2v4a2 2 0 0 0 2 2h8.025A5.039 5.039 0 0 1 12 17v-4.198a3 3 0 0 1 1.617-2.663Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M14.783 11.826a1 1 0 0 0-.783.976V17c0 2.302 2.649 3.72 3.882 4.256.397.173.84.173 1.236 0C20.351 20.72 23 19.302 23 17v-4.198a1 1 0 0 0-.783-.976l-3.066-.681a2.999 2.999 0 0 0-1.302 0l-3.066.681Zm6.336 3.543a.875.875 0 1 0-1.238-1.238l-2.131 2.132-.631-.632a.875.875 0 1 0-1.238 1.238l1.25 1.25a.875.875 0 0 0 1.238 0l2.75-2.75Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcAssurance");

export { IcAssurance };
//# sourceMappingURL=ic-assurance.js.map
